// Store context recoverable from the current URL, for minting anonymous
// tokens on franchise domains. A franchise root domain (e.g.
// order.leankitchenco.com) can't resolve a merchant from the subdomain alone —
// the backend needs a store_slug or bottle_id to pick the right location.
// Recognised shapes: /:slug, /:slug/b/:id, /:slug/s/:id, /b/:id, /s/:id.
// Anything else (multi-segment non-store routes like /gc/:code) yields {}.
// A lone segment may be a non-store route ('login', 'profile', ...) — the
// backend just fails the slug lookup and mints a merchant-less token, same as
// sending nothing. BOT-1295.
export function franchiseStoreContextFromLocation() {
  const segments = window.location.pathname.split('/').filter(Boolean)
  const markerIndex = segments.findIndex((segment) => segment === 'b' || segment === 's')

  const context = {}
  if (markerIndex > 0) {
    context.store_slug = segments[0]
  } else if (markerIndex === -1 && segments.length === 1) {
    context.store_slug = segments[0]
  }
  if (segments[markerIndex] === 'b' && segments[markerIndex + 1]) {
    context.bottle_id = segments[markerIndex + 1]
  }
  return context
}
